var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            width: "40%",
            "modal-append-to-body": false,
            "append-to-body": "",
          },
          on: { close: _vm.handleClose },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "baseForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "激活码名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入激活码名称",
                      clearable: "",
                      maxlength: "99",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "激活码会员类型", prop: "memberTypeId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择激活码会员类型",
                        clearable: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.form.memberTypeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "memberTypeId", $$v)
                        },
                        expression: "form.memberTypeId",
                      },
                    },
                    _vm._l(_vm.cdkeyMemberList.value, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "定价周期", prop: "salePeriod" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入数字",
                    },
                    model: {
                      value: _vm.form.salePeriod,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "salePeriod", $$v)
                      },
                      expression: "form.salePeriod",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "salePeriodUnit" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        size: "small",
                        placeholder: "请选择定价周期单位",
                      },
                      model: {
                        value: _vm.form.salePeriodUnit,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "salePeriodUnit", $$v)
                        },
                        expression: "form.salePeriodUnit",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "日", value: 1 } }),
                      _c("el-option", { attrs: { label: "月", value: 2 } }),
                      _c("el-option", { attrs: { label: "季", value: 3 } }),
                      _c("el-option", { attrs: { label: "年", value: 4 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "售价", prop: "salePrice" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入金额",
                    },
                    model: {
                      value: _vm.form.salePrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "salePrice", $$v)
                      },
                      expression: "form.salePrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联运商品", prop: "unionGoodsId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择联运商品",
                        clearable: "",
                        size: "small",
                      },
                      on: { change: _vm.selectUnionGoods },
                      model: {
                        value: _vm.form.unionGoodsId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "unionGoodsId", $$v)
                        },
                        expression: "form.unionGoodsId",
                      },
                    },
                    _vm._l(_vm.unionGoodsList.value, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.goodsName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.form.unionGoodsId && _vm.form.unionGoodsId !== 0
                ? _c("el-form-item", { attrs: { label: " " } }, [
                    _c("span", [_vm._v(_vm._s(_vm.unionGoodsShow))]),
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "前端可见", prop: "frontVisible" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.frontVisible,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "frontVisible", $$v)
                        },
                        expression: "form.frontVisible",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "descr" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      "show-limit-word": "",
                      clearable: "",
                      maxlength: "9999",
                      size: "small",
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.form.descr,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "descr", $$v)
                      },
                      expression: "form.descr",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.hide } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }